<template>
  <div>
    <div class="v_box1">
      <div class="b_banxin">
        <ul class="navbox flex">
          <li class=" navboxliico">
            <img src="@/assets/img/shouye.png" alt="" class="v_ico">
            <span style="display: inline-block;">
              首页
            </span>
          </li>
          <li class=" navboxliico">
            限时抢购
          </li>
          <span v-for="(item,index) in tabval" :key="index" :class="{navboxli:active==index}">
            {{item.tabname}}
          </span>
        </ul>
      </div>
    </div>
    <div class="v_box2">
      <div class="b_banxin">
        <div class="v_box2top flex">
          <div class="v_box2topleft flex">
            <div v-for="(item,index) in tabval" :key="index" :class="{v_box2topactive:active==index}"
              @click="tabpost(index)">
              {{item.tabname}}
            </div>
          </div>
          <div class="v_box2topright flex">
            <div class="v_box2toprighttxt">
              {{tabtxt}}
            </div>
            <countdown :time="countdowns1" @countdownClose="countdownShow=false" v-if="tabtxt == '已结束'"></countdown>
            <countdown :time="countdowns" @countdownClose="countdownShow=false" v-if="tabtxt == '距结束'"></countdown>
            <countdowns :time="countdowns2" @countdownClose="countdownShow=false" v-if="tabtxt == '距开始'"></countdowns>
          </div>
        </div>
        <div class="v_boxrtbtn">
          <seckillshopbox :shoplist="shoplist2" :shoptype="active"></seckillshopbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import countdown from '@/views/index/indexseckill/countdown.vue'
    import countdowns from '@/views/index/indexseckill/countdowns.vue'
    import seckillshopbox from '@/views/index/indexseckill/seckillshopbox.vue'
    import qs from "qs";
    export default {
        components: {
            countdown,
            countdowns,
            seckillshopbox
        },
        data() {
            return {
                active: 1,
              countdowns1:0,//倒计时
              countdowns:0,//倒计时
              countdowns2:0,//倒计时
                tabtxt: '',
                tabval: [{
                    tabname: '上期回顾',
                    countdowns: 0,
                }, {
                    tabname: '火热进行中',
                    countdowns: 0,
                }, {
                    tabname: '下期预告',
                    countdowns: 0,
                }],
                shoplist2: [],
              newShop1:{},//疯狂抢购所需参数
              newShop2:{},//上期回顾
              newShop3:{},//火热购买
              newShop4:{},//下期预告
            }
        },
      created() {
        let that = this;
        if (that.$storage.get("user_data") != null) {
          that.newShop1["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop2["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop3["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop4["userrole"] = that.$storage.get("user_data").rank_id;
        } else {

          that.newShop1["userrole"] = 1;
          that.newShop2["userrole"] = 1;
          that.newShop3["userrole"] = 1;
          that.newShop4["userrole"] = 1;

        }
        
        that.newShopFn1('');
        that.newShopFn3();
        that.newShopFn4();
       

      },
      mounted() {
			window.addEventListener("scroll", this.handleScroll);
			let that = this;
        if (that.$storage.get("user_data") != null) {
          that.newShop1["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop2["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop3["userrole"] = that.$storage.get("user_data").rank_id;
          that.newShop4["userrole"] = that.$storage.get("user_data").rank_id;
        } else {

          that.newShop1["userrole"] = 1;
          that.newShop2["userrole"] = 1;
          that.newShop3["userrole"] = 1;
          that.newShop4["userrole"] = 1;

        }
       
        that.newShopFn1('');
        that.newShopFn3();
        that.newShopFn4();
//       that.tabtxt = '距结束';
		},
        methods: {
            tabpost(index) {
                this.active = index
                if (index == "0") {
                    this.tabtxt = '已结束'
                  this.newShopFn1('last')
                } else if (index == "1") {
                    this.tabtxt = '距结束'
                  this.newShopFn1('')
                } else if (index == "2") {

                  this.tabtxt = '距开始';
                  this.newShopFn1('next')

                }
            },
          newShopFn1(period = '') {
            let that = this;
            that.newShop1['period'] = period;

            axios({
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
              },
              url: that.$publicUrl.http1 + that.$publicUrl.promotionspanic_buyingget,
              data: qs.stringify(that.newShop1)
            })
              .then(function(response) {
                let data = response.data;
                if (data.stateCode == 10000) {
                  let arrshop = data.data.goods;
                  for (let i in arrshop) {
                    arrshop[i].panic_price = arrshop[i].skus[0].panic_price;
                    arrshop[i].original_price = arrshop[i].skus[0].original_price;
                    arrshop[i].sku_id = arrshop[i].skus[0].id;
                    arrshop[i].panic_id = data.data.id;
                    if(arrshop[i].sold / arrshop[i].total * 100 < 1){
                    	arrshop[i].yishoubili = (arrshop[i].sold / arrshop[i].total * 100).toFixed(2);
                    }else{
                    	arrshop[i].yishoubili = parseInt(arrshop[i].sold / arrshop[i].total * 100)
                    }
                    let arr = [];
			              let arr_ = JSON.parse(arrshop[i].skus[0].spec)
			              for(let s in arr_){
			              	arr.push(arr_[s].name)
			              }
			              arrshop[i].specs = arr.toString();
//                  arrshop[i].yishoubili = arrshop[i].sold / arrshop[i].total * 100 < 1 ? (arrshop[i].sold / arrshop[i].total * 100).toFixed(2) : parseInt(arrshop[i].sold / arrshop[i].total * 100)
                    for (let t in arrshop[i].skus){
                      arrshop[i].skus[t].goods_id = arrshop[i].id;
                      arrshop[i].skus[t].panic_id = data.data.id;
                    }
                  }
                  console.log(arrshop[0])

                  that.shoplist2 = arrshop;

                } else {
                  that.shoplist2 = [];
                }
              })
              .catch(function(error) {});
          },
          newShopFn3(period = '') {
            let that = this;
            that.newShop3['period'] = period;

            axios({
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
              },
              url: that.$publicUrl.http1 + that.$publicUrl.promotionspanic_buyingget,
              data: qs.stringify(that.newShop3)
            })
              .then(function(response) {
                let data = response.data;
                if (data.stateCode == 10000) {
                  let arrshop = data.data.goods;
                  that.countdowns = data.data.end_time;
                   that.tabtxt = '距结束';



                } else {
                }
              })
              .catch(function(error) {});
          },
          newShopFn4(period = 'next') {
            let that = this;
            that.newShop4['period'] = period;

            axios({
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
              },
              url: that.$publicUrl.http1 + that.$publicUrl.promotionspanic_buyingget,
              data: qs.stringify(that.newShop4)
            })
              .then(function(response) {
                let data = response.data;
                if (data.stateCode == 10000) {
                  let arrshop = data.data.goods;
                  that.countdowns2 = data.data.start_time;



                } else {
                }
              })
              .catch(function(error) {});
          },

        },
    }
</script>
<style scoped>
    .v_box1 {
        width: 100%;
        background-color: #f6f6f6;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .navbox {
        height: 20px;
    }

    .navbox li {
        display: inline-block;
        height: 20px;
        font-size: 16px;
        padding: 0 5px;
        vertical-align: top;
        margin-right: 20px;
        position: relative;
    }

    .navboxli li span {
        display: inline-block;
        height: 20px;
        font-size: 16px;
        vertical-align: top;
    }

    .navbox span {
        display: none;
    }

    .navbox .navboxli {
        display: inline-block;
        height: 20px;
        font-size: 16px;
        padding: 0 5px;
        vertical-align: top;
        margin-right: 20px;
        position: relative;
    }

    .navboxliico:after {
        content: "\e6e0";
        font-size: 15px;
        position: absolute;
        top: 58%;
        right: -16px;
        transform: translateY(-50%);
        color: #585858;
        font-family: element-icons !important;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        vertical-align: baseline;
        display: inline-block;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .v_ico {
        width: 19px;
        height: 19px;
        display: inline-block;
        object-fit: scale-down;
        vertical-align: top;
        margin-right: 10px;
    }

    .v_box2 {
        width: 100%;
        background-color: #ffffff;
        min-height: 600px;
    }

    .v_box2top {
        width: 100%;
        box-sizing: border-box;
        padding: 30px 20px;
        border-bottom: 2px solid #dc1e33;
    }

    .v_box2topleft {
        width: 790px;
        height: 60px;
    }

    .v_box2topleft div {
        width: 260px;
        height: 60px;
        box-sizing: border-box;
        text-align: center;
        line-height: 60px;
        font-size: 24px;
        margin-left: 10px;
        -webkit-clip-path: polygon(10% 0, 100% 1%, 90% 100%, 0% 100%);
        clip-path: polygon(10% 0, 100% 1%, 90% 100%, 0% 100%);
        background-color: #eeeeee;
        cursor: pointer;
        color: #000000;
    }

    .v_box2topleft .v_box2topactive {
        background-color: #dc1e33;
        color: #ffffff;
    }

    .v_box2topright {
        width: 370px;
        height: 60px;
    }

    .v_box2topright span {
        display: none;
    }

    .v_box2topright .span {
        display: inline-block;
    }

    .v_box2toprighttxt {
        width: 100px;
        height: 60px;
        line-height: 60px;
        font-size: 22px;
        color: #dc1e33;
        box-sizing: border-box;
        padding: 0 5px;
    }

    .v_box2toprightime {
        width: calc(100% - 85px);
    }

    .v_boxrtbtn {
        width: 100%;
        min-height: 200px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 30px;
        padding-left: 20px;
    }
</style>
